import { render, staticRenderFns } from "./Origin_masters.vue?vue&type=template&id=1ba29d36&"
import script from "./Origin_masters.vue?vue&type=script&lang=js&"
export * from "./Origin_masters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports